import classNames from 'classnames';
import React from 'react';

interface LogoGridProps {
  /** Logos to display. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string;
  childrenClassName?: string;
  /** Headline to display. */
  header?: React.ReactNode;
}

/** Display Grid of logos with optional headline. */
const LogoGrid = ({
  children,
  childrenClassName,
  className,
  header,
}: LogoGridProps) => (
  <div className={classNames(className, 'ce ce-logo-grid text-center')}>
    {header}
    <div className={classNames(childrenClassName, 'ce-logo-grid-wrapper')}>
      {children}
    </div>
  </div>
);

LogoGrid.defaultProps = {
  childrenClassName: null,
  className: null,
  header: null,
};

export default LogoGrid;
